<template>
  <TopNav></TopNav>
  <h1>Mortgage Calculator</h1>
  <fieldset>
    <legend>Mortgage Calculator</legend>
    <label for="a">Principal: </label> <input type="number" v-model.number="principal" id="a" step="any" min="0"> $
    <br>
    <label for="b">Annual Interest Rate: </label> <input type="number" v-model.number="interest" id="b" step="any" min="0"> %
    <br>
    <label for="b">Number of Months: </label> <input type="number" v-model.number="months" id="b" step="1" min="1"> months
    <br><br>
    Monthly payment of ${{ principalFormatted() }} principal with {{ interest }}% annual interest rate for {{ months }}
    months will be <span class="blue">${{ mortgagePayment() }}</span>.
  </fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

export default {
  name: "Mortgage",
  data() {
    return {
      principal: 125000,
      interest: 1,
      months: 60,
    }
  },
  components: {
    TopNav
  },
  methods: {
    mortgagePayment: function () {
      let rate = (1 + (this.interest / 12) / 100);
      let interestRate = Math.pow(rate, this.months);
      let paymentAmount = this.principal * (((this.interest / 12) / 100) * interestRate) / (interestRate - 1);
      let finalNumber = Number(paymentAmount);
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2
      });
      return formatter.format(finalNumber);
    },
    principalFormatted: function () {
      const formatter = new Intl.NumberFormat('en-US', {
        maximumFractionDigits: 2
      });
      return formatter.format(this.principal);
    }
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  min-width: 200px;
}

footer section a {
  margin: 20px;
}

.blue {
  color: blue;
}
</style>
